const GAME_TYPE = import.meta.env.VITE_GAME_TYPE || "twins";

/**
 * Динамические импорты игровых чанков. Вынесены в отдельный модуль, чтобы
 * прогрев на входе в приложение и `lazy()` в `HomeGame` ссылались на одни и те
 * же промисы — бандлер переиспользует уже загруженный чанк.
 */
export const preloadPioneerGame = () =>
  import("./pioneer/PioneerGame/PioneerGame");

export const preloadTwinsGame = () => import("./twins/TwinsGame");

/** Чанк игры, собранной в текущем билде. */
export const preloadActiveGame = () =>
  GAME_TYPE === "pioneer" ? preloadPioneerGame() : preloadTwinsGame();
